import { useQuery } from '@tanstack/react-query';
import { billingApi } from '../services/billingApi';
import { BillingDocument } from '../types/billing';

/**
 * Hook for fetching billing documents
 *
 * Uses React Query for caching and automatic refetching.
 * Data is cached for 5 minutes.
 *
 * @returns Query result with billing documents
 */
export const useBillingDocuments = () => {
  return useQuery<BillingDocument[], Error>({
    queryKey: ['billing-documents'],
    queryFn: () => billingApi.getDocuments(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
